import styled from "styled-components";

export const BoxRelative = styled.div`
    position: relative;
    height: 65;
    width: 220px;
    margin: 10px 10px 5px 0;
`;
